{
  "live_ops": "Live Ops",
  "governance": "Gouvernance",
  "lab": "Lab",
  "overview": "Vue d'ensemble",
  "anomalies": "Anomalies · flux",
  "flows": "Flux",
  "incidents": "Incidents · sources",
  "novelty_candidates": "Candidats nouveauté",
  "campaigns": "Campagnes · clusters",
  "model_health": "Santé Modèle",
  "cost_budget": "Coût / Risque",
  "suppression_suggestions": "Suppr. Suggérées",
  "topology": "Topologie",
  "shadow_mode": "Mode Shadow",
  "honey_traps": "Honey Traps",
  "war_mode": "Mode Guerre",
  "models": "Modèles",
  "trusted": "Sources de confiance",
  "baselines": "Baselines",
  "thresholds": "Seuils",
  "fleet_shifts": "Décalage fleet",
  "host_baseline_policy": "Policy baseline",
  "judge_config": "Juges",
  "shadow_review": "Revue Shadow",
  "probe_setup": "Installation sonde",
  "post_quantum": "Post-Quantique",
  "wasm_inference": "Inférence WASM",
  "entropy": "Entropie",
  "red_team": "Red Team",
  "sbom": "SBOM",
  "federated": "Fédéré",
  "arbiter": "Arbitre",
  "users": "Utilisateurs"
}
